import React, { useRef } from "react";
import { useLanguage } from "../context/LanguageContext";
import { getTranslations } from "../data/translations/index";
import { useReveal } from "../hooks/useReveal";
import { DownloadButton } from "./DownloadButton";
import "../styles/EntryCard.css";

export const ExperienceItem = () => {
  const { language } = useLanguage();
  const { Experience } = getTranslations(language);
  const rootRef = useRef(null);
  useReveal(rootRef, language);

  return (
    <div className="entry-list container" ref={rootRef}>
      {Experience.map((experience, index) => (
        <article
          className="entry glass glass--interactive"
          key={experience.id}
          data-reveal
          style={{ "--reveal-delay": `${Math.min(index, 4) * 0.06}s` }}
        >
          <div className="entry__aside">
            <a
              className="entry__logo-link"
              href={experience.href}
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="entry__logo"
                src={experience.src}
                alt={experience.company}
              />
            </a>
            <h3 className="entry__company">{experience.company}</h3>
            <p className="entry__location">{experience.location}</p>
          </div>

          <div className="entry__main">
            <p className="entry__date">{experience.date}</p>
            <h2 className="entry__title">{experience.position}</h2>
            <ul className="entry__points">
              {experience.details.map((detail, i) => (
                <li key={i}>{detail}</li>
              ))}
            </ul>
            <div className="entry__actions">
              <DownloadButton button={experience.button} />
              <DownloadButton button={experience.button2} />
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};
